export type UsersModel = { email: string; roleId: number; id?: string };
export type RegisterUserModel = { email: string; sendAccountCreationConfirmationEmail: boolean };
export type RemoveUserModel = { email: string };

export const defaultRegisterUserModel: RegisterUserModel = { email: '', sendAccountCreationConfirmationEmail: false };
export const defaultUserModel: UsersModel = { id: '', email: '', roleId: 1 };
